/* GastroStars Mega-Menue.
 * Reines :hover reisst das Panel weg, sobald die Maus die Kachel verlaesst.
 * Hier haelt jedes offene Fenster eine halbe Sekunde. Beim Wechsel wird erst
 * geschlossen und danach das naechste geoeffnet, nie beides gleichzeitig.
 * Sonst ueberlappen sich zwei verschieden hohe Panels. */
(function () {
  var OPEN = 200;
  var HOLD = 500;
  var FADE = 170;
  var LEAVE = 500;
  var BILD_BREITE = 340;

  /* Das Kategoriebild steckt schon in der Kachel. Statt es ein zweites Mal
   * aus Liquid zu rendern, wird es in den Kopf des Fensters kopiert.
   * Die Kachel laedt nur 64px breit, im Fenster steht es viermal so gross.
   * Deshalb srcset weg und eine groessere Variante von der CDN anfordern,
   * sonst ist die Kopie unscharf. */
  function bildKopieren(item) {
    var quelle = item.querySelector('.gs-athens-category__media');
    var kopf = item.querySelector('.gs-athens-category__submenu-head');
    if (!quelle || !kopf) { return; }
    if (kopf.querySelector('.gs-athens-category__submenu-media')) { return; }

    var kopie = quelle.cloneNode(true);
    kopie.className = 'gs-athens-category__submenu-media';
    kopie.setAttribute('aria-hidden', 'true');

    var img = kopie.querySelector('img');
    if (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('width');
      img.removeAttribute('height');
      var src = img.getAttribute('src') || '';
      if (/([?&])width=\d+/.test(src)) {
        img.setAttribute('src', src.replace(/([?&])width=\d+/, '$1width=' + BILD_BREITE));
      }
    }

    kopf.appendChild(kopie);
  }

  function init() {
    var nav = document.querySelector('.gs-athens-categories');
    if (!nav) { return; }
    var items = nav.querySelectorAll('.gs-athens-category-item');
    if (!items.length) { return; }

    var active = null;
    var want = null;
    var tOpen = 0;
    var tSwap = 0;
    var tShut = 0;

    function clear() {
      clearTimeout(tOpen);
      clearTimeout(tSwap);
      clearTimeout(tShut);
    }

    function show(item) {
      if (!item) { return; }
      if (active && active !== item) { active.classList.remove('is-open'); }
      item.classList.add('is-open');
      active = item;
    }

    function shut() {
      if (active) { active.classList.remove('is-open'); }
      active = null;
      want = null;
    }

    function ask(item) {
      if (item === active) { clear(); want = null; return; }
      clear();
      want = item;
      if (!active) {
        tOpen = setTimeout(function () { show(want); }, OPEN);
        return;
      }
      tSwap = setTimeout(function () {
        if (active) { active.classList.remove('is-open'); }
        active = null;
        tSwap = setTimeout(function () { show(want); }, FADE);
      }, HOLD);
    }

    Array.prototype.forEach.call(items, function (item) {
      bildKopieren(item);
      item.addEventListener('pointerenter', function () { ask(item); });
      item.addEventListener('focusin', function () { clear(); show(item); });
    });

    nav.addEventListener('pointerenter', function () { clearTimeout(tShut); });
    nav.addEventListener('pointerleave', function () {
      clearTimeout(tOpen);
      clearTimeout(tSwap);
      tShut = setTimeout(shut, LEAVE);
    });
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) { shut(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { clear(); shut(); }
    });

    nav.setAttribute('data-gs-menu', 'js');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
